import * as React from 'react';
import { useEffect, useState } from 'react';
import { Button, Modal, Divider, EmptyState} from '@iba-team/portal-react-components/dist';
import { DaysAvailableNamespace } from '../types';
import { useTranslation } from 'react-i18next';
import './AllowanceModalStyles.scss';
import { observer } from 'mobx-react';
import { DaysAvailableStore } from '../../../../store/DaysAvailable';
import { format } from 'date-fns';
import { useCloseModal } from '../../../../utils/hooks';
import { ReactComponent as EmptyHistory } from '../../../../assets/icons/empty-history.svg';
import { Spinner } from '@iba-team/portal-react-components/dist';
import './HistoryModal.scss';

const HistoryModal = observer((props: DaysAvailableNamespace.HistoryModalCallProps) => {
  const {t} = useTranslation();
  const closeModal = useCloseModal(props.onClose, 'history');
  const {getUserBalanceHistory} = DaysAvailableStore;
  const [history, setHistory] = useState<DaysAvailableNamespace.BalanceHistoryCollection>([]);
  const [spinner, setSpinner] = useState(true);

  useEffect(() => {
    getUserBalanceHistory(props.userId).then(res => {
      setSpinner(false);
      setHistory(res);
    });
  }, [props.userId]);

  const renderHistory = () => {
    if (spinner) {
      return (
        <div className={'spinner_wrapper'}>
          <Spinner/>
        </div>
      );
    }

    if (history.length === 0) {
      return (
        <EmptyState
          className={'empty'}
          title={t('availableDays.modals.history.emptyHistoryTitle')}
          description={t('availableDays.modals.history.emptyHistoryDescr')}
          icon={<EmptyHistory/>}
        />
      );
    }

    return history.map(el => {
      const groupDate = new Date(el.date);
      return  <div className={'days-available-history__dayGroup'}>
        <div className={'days-available-history__dayGroup__date'}>
          <Divider/>
          <span>{format(groupDate, 'dd.MM.yyyy')}</span>
          <Divider/>
        </div>
        <div className={'days-available-history__dayGroup__container'}>
          {el.changesHistory.map(message => {
            return <div className={'days-available-history__dayGroup__message'}>
              <span className={'days-available-history__dayGroup__message__time'}>{message.balanceChangeTime}</span>
              <div className={'days-available-history__dayGroup__message__text'} dangerouslySetInnerHTML={{__html: message.balanceChangeMessage}}></div>
            </div>;
          }
          )}
        </div>
      </div>;
    });
  };

  const footer = [
    <Button theme={{color: 'grey', variant: 'neutral'}} onClick={closeModal}>{t('buttons.close')}</Button>,
  ];
  return (
    <Modal visible={true}
      titleText={t('availableDays.modals.history.title')}
      footer={footer}
      onClose={closeModal}>
      <div className={'days-available-history'}>
        {renderHistory()}
      </div>
    </Modal>
  );
});

export default HistoryModal;